module.exports = __webpack_public_path__ + "assets/img/teacher_top4.53057d64.png";